<template>
  <el-dialog :title="isUpdate ? '编辑类型' : '添加类型'" :visible="visible" width="720px" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="类型名称:" prop="type_code">
            <el-select v-model="form.type_code" placeholder="请选择" class="ele-block" @change="handleTypeChange">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型编码:" prop="channel_code">
            <el-input v-model="form.channel_code" :disabled="isUpdate" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDictData } from '@/utils/dict';

const emptyForm = () => ({
  type_code: '',
  channel_code: '',
  channel_name: '',
  status: 1
});

export default {
  name: 'TypeEdit',
  props: {
    visible: Boolean,
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: emptyForm(),
      rules: {
        type_code: [{ required: true, message: '请选择', trigger: 'change' }],
        channel_code: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false,
      options: []
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.resetFields();
          this.form = emptyForm();
          this.isUpdate = false;
        });
        return;
      }
      this.initForm();
      this.getOptions();
    }
  },
  methods: {
    initForm() {
      if (this.data) {
        this.form = Object.assign(emptyForm(), this.data);
        this.isUpdate = true;
      } else {
        this.form = emptyForm();
        this.isUpdate = false;
      }
    },
    getOptions() {
      getDictData('type_name')
        .then((list) => {
          this.options = (list || []).map((item) => ({
            value: item.dictDataCode,
            label: item.dictDataName
          }));
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    handleTypeChange(value) {
      const selected = this.options.find((item) => item.value === value);
      if (selected) {
        this.form.channel_name = selected.label;
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$http.post('/channeltype/edit', this.form)
          .then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
